import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { IInputsState } from '../../types/form';

export enum EFormActionTypes {
  SetIsLoading = 'FORM/SET_IS_LOADING',
  SetIsFileUploading = 'FORM/SET_IS_FILE_UPLOADING',
  SetFileUploadingProgress = 'FORM/SET_FILE_UPLOADING_PROGRESS',
  SetErrors = 'FORM/SET_ERRORS',
  SetIsSubmitted = 'FORM/SET_IS_SUBMITTED',
  ResetForm = 'FORM/RESET',
  SetInputsState = 'FORM/SET_INPUTS',
  ResetFileState = 'FORM/RESET_FILE_STATE',
  RemoveFileByName = 'FORM/REMOVE_FILE_BY_NAME',
}

export type TSetIsLoading = ITypedReduxAction<EFormActionTypes.SetIsLoading, boolean>;
export type TSetIsFileUploading = ITypedReduxAction<EFormActionTypes.SetIsFileUploading, boolean>;
export type TSetFileUploadingProgress = ITypedReduxAction<EFormActionTypes.SetFileUploadingProgress, number>;
export type TSetErrors = ITypedReduxAction<EFormActionTypes.SetErrors, {}>;
export type TSetIsSubmitted = ITypedReduxAction<EFormActionTypes.SetIsSubmitted, boolean>;
export type TResetForm = ITypedReduxAction<EFormActionTypes.ResetForm>;
export type TSetInputsState = ITypedReduxAction<EFormActionTypes.SetInputsState, Partial<IInputsState>>;
export type TResetFileState = ITypedReduxAction<EFormActionTypes.ResetFileState>;
export type TRemoveFileByName = ITypedReduxAction<EFormActionTypes.RemoveFileByName, string>;

export const setIsLoading: (isLoading: boolean) => TSetIsLoading = actionGenerator<
  EFormActionTypes.SetIsLoading,
  boolean
>(EFormActionTypes.SetIsLoading);

export const setIsFileUploading: (isLoading: boolean) => TSetIsFileUploading = actionGenerator<
  EFormActionTypes.SetIsFileUploading,
  boolean
>(EFormActionTypes.SetIsFileUploading);

export const setFileUploadingProgress: (fileUploadingProgress: number) => TSetFileUploadingProgress = actionGenerator<
  EFormActionTypes.SetFileUploadingProgress,
  number
>(EFormActionTypes.SetFileUploadingProgress);

export const setIsSubmitted: (isSubmitted: boolean) => TSetIsSubmitted = actionGenerator<
  EFormActionTypes.SetIsSubmitted,
  boolean
>(EFormActionTypes.SetIsSubmitted);

export const setErrors: (errors?: { [key: string]: string }) => TSetErrors = actionGenerator<
  EFormActionTypes.SetErrors,
  { [key: string]: string } | {}
>(EFormActionTypes.SetErrors);

export const setInputsState: (arg: Partial<IInputsState>) => TSetInputsState = actionGenerator<
  EFormActionTypes.SetInputsState,
  Partial<IInputsState>
>(EFormActionTypes.SetInputsState);

export const resetForm: () => TResetForm = actionGenerator<EFormActionTypes.ResetForm>(EFormActionTypes.ResetForm);

export const resetFileState: () => TResetFileState = actionGenerator<EFormActionTypes.ResetFileState>(
  EFormActionTypes.ResetFileState,
);

export const removeFileByName: (fileName: string) => TRemoveFileByName = actionGenerator<
  EFormActionTypes.RemoveFileByName,
  string
>(EFormActionTypes.RemoveFileByName);

export type TFormActions =
  | TSetIsLoading
  | TSetIsFileUploading
  | TSetFileUploadingProgress
  | TSetErrors
  | TSetIsSubmitted
  | TResetForm
  | TSetInputsState
  | TResetFileState
  | TRemoveFileByName;
